import React, { Component, createRef } from "react";
import { RichUtils, EditorUtils, EditorState } from "draft-js";
import { Button, Icon, Input } from "semantic-ui-react";

class LinkButton extends Component {
  state = {
    active: false,
    open: false,
    url: ""
  };

  input = createRef();
  async componentDidUpdate() {
    const currentActiveStatus = this.isStyleActive();
    if (currentActiveStatus !== this.state.active) {
      this.setState({ active: currentActiveStatus });
    }
  }
  handleChangeInput = (event, { value }) => this.setState({ url: value });

  handleButtonClick = () => {
    if (this.state.active) {
      const newEditorState = RichUtils.toggleInlineStyle(
        this.props.getEditorState(),
        "LINK"
      );
      return this.props.setEditorState(
        this.removeLinkAtSelection(newEditorState)
      );
    }
    if (this.state.open) {
      let { url } = this.state;
      this.setState({ url: "", open: false }, () => {
        const newEditorState = RichUtils.toggleInlineStyle(
          this.props.getEditorState(),
          "LINK"
        );
        return this.props.setEditorState(
          this.createLinkAtSelection(newEditorState, { url })
        );
      });
    } else {
      this.setState({ open: true }, () => this.input.focus());
    }
  };

  handleClose = () => {
    this.setState({ url: "", open: false });
  };

  toggleStyle = event => {
    event.preventDefault();

    const newEditorState = RichUtils.toggleInlineStyle(
      this.props.getEditorState(),
      "LINK"
    );
    if (this.state.active) {
      return this.props.setEditorState(
        this.removeLinkAtSelection(newEditorState)
      );
    }
    return this.props.setEditorState(
      this.createLinkAtSelection(newEditorState)
    );
  };

  preventBubble = event => event.preventDefault();

  isStyleActive = () => {
    if (!this.props.getEditorState) {
      return false;
    }
    const editorState = this.props.getEditorState();
    const block = editorState
      .getCurrentContent()
      .getBlockForKey(editorState.getSelection().getAnchorKey());

    let { anchorOffset, isBackwards } = editorState.getSelection();
    let index = isBackwards ? anchorOffset - 1 : anchorOffset;
    let key = block.getEntityAt(index);
    if (key) {
      const type = editorState
        .getCurrentContent()
        .getEntity(key)
        .getType();
      return type === "LINK";
    }
    return false;
  };

  removeLinkAtSelection(editorState) {
    const selection = editorState.getSelection();
    return RichUtils.toggleLink(editorState, selection, null);
  }

  createLinkAtSelection(editorState, { url }) {
    const contentState = editorState
      .getCurrentContent()
      .createEntity("LINK", "MUTABLE", {
        url
      });
    const entityKey = contentState.getLastCreatedEntityKey();
    const withLink = RichUtils.toggleLink(
      editorState,
      editorState.getSelection(),
      entityKey
    );
    return EditorState.forceSelection(withLink, editorState.getSelection());
  }

  render() {
    return (
      <div onMouseDown={this.preventBubble}>
        {this.state.open ? (
          <Input
            onBlur={this.handleBlur}
            onChange={this.handleChangeInput}
            value={this.state.url}
            placeholder="http://..."
            ref={element => (this.input = element)}
            action={
              <Button
                icon
                active={this.state.active}
                onClick={
                  this.state.url ? this.handleButtonClick : this.handleClose
                }
              >
                <Icon name={this.state.url ? "linkify" : "close"} />
              </Button>
            }
          />
        ) : (
          <Button
            icon
            active={this.state.active}
            onClick={this.handleButtonClick}
          >
            <Icon name={this.state.active ? "unlinkify" : "linkify"} />
          </Button>
        )}
      </div>
    );
  }
}
export default LinkButton;



// WEBPACK FOOTER //
// ./src/pages/Contents/New/EditorButtons/LinkButton.js